import React, { useEffect } from "react";
import {
  Button,
  makeStyles,
  Typography,
  DialogContent,
  DialogActions,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { useHistory } from "react-router";
import { t } from "@configuratorware/configurator-frontendgui/Framework/i18n";
import CustomDialog from "@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog";
import { get, sum, values } from "lodash";

export const useStyles = makeStyles((theme) => ({
  loginDialog: {
    maxWidth: 450,
    margin: "auto",
  },
  closeIcon: {
    position: "absolute",
    right: 28,
    top: 28,

    [theme.breakpoints.down("xs")]: {
      right: 20,
      top: 30,
    },

    "&:hover": {
      cursor: "pointer",
    },
  },
  dialogPosition: {
    position: "absolute",
    width: "100%",
    top: 60,
    borderTop: "7px solid " + theme.palette.primary.main,
    [theme.breakpoints.down("xs")]: {
      top: 0,
    },
  },
  itemContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",

    "& img": {
      width: "100%",
    },
  },
  itemImage: {},
  activeButton: {
    width: "100%",
    padding: 8,
    textTransform: "none",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    "&:hover": {
      backgroundColor: theme.palette.primary.main,
    },
  },
}));

export interface BasketListProps {
  show: boolean;
  onClose: () => void;
  isLoggedIn: boolean;
  loadBasket: () => void;
  basketItems: any[];
}

const BasketList = (props: BasketListProps) => {
  const classes = useStyles();
  const { show, onClose, isLoggedIn, basketItems } = props;
  const history = useHistory();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("xs"));

  useEffect(() => {
    show && props.loadBasket();
  }, [show]);

  return (
    <CustomDialog
      open={show}
      className={classes.loginDialog}
      fullScreen={isSmallScreen}
      dialogTitle={
        isLoggedIn ? t("basketList.cartTitle") : t("basketList.requestTitle")
      }
      onCancel={onClose}
    >
      <DialogContent>
        {basketItems.map((item, i) => (
          <div className={classes.itemContainer} key={i}>
            <Typography variant="body2">
              {sum(
                values(get(item, "configuration.customdata.selectedAmounts", 0))
              ) +
                " x " +
                get(item, "configuration.item.title", "")}
            </Typography>
            <img
              className={classes.itemImage}
              src={item.configuration.images[0]}
            />
          </div>
        ))}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() =>
            history.push({
              pathname: "/basket/address",
              search: window.location.search,
            })
          }
          variant="contained"
          classes={{ root: classes.activeButton }}
        >
          {isLoggedIn
            ? t("basketList.goToCartView")
            : t("basketList.goToRequestView")}
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default BasketList;
